import {
  GET_TASKS, GET_TASK, CREATE_TASK, EDIT_TASK, DELETE_TASK, UPDATE_TASK_STATUS,
} from './task.types';

export const taskActions = {
  getTasks: (params) => ({
    type: GET_TASKS,
    payload: params,
  }),
  getTask: (id) => ({
    type: GET_TASK,
    payload: id,
  }),
  createTask: (data) => ({
    type: CREATE_TASK,
    payload: data,
  }),
  editTask: (id, data) => ({
    type: EDIT_TASK,
    payload: { id, data },
  }),
  deleteTask: (id) => ({
    type: DELETE_TASK,
    payload: id,
  }),
  updateTaskStatus: (id, status) => ({
    type: UPDATE_TASK_STATUS,
    payload: { id, status },
  }),
};
